import React from 'react';

export function colorPresentation(value, colorSettings = {}) {
  const normalized = String(value || '').trim().toLocaleLowerCase('es');
  const match = Object.entries(colorSettings).find(([code, data]) => code.toLocaleLowerCase('es') === normalized
    || String(data?.description || '').trim().toLocaleLowerCase('es') === normalized);
  return { code: match?.[0] || '', description: match?.[1]?.description || value || 'Color pendiente', hex: match?.[1]?.hex || null };
}

export function ColorVariantBadge({ color, variant, colorSettings = {} }) {
  const base = variant?.garment_color || color;
  const info = colorPresentation(base, colorSettings);
  const variantLabel = color !== base ? (color.startsWith(`${base} · `) ? color.slice(base.length + 3) : color) : '';
  return <div className="flex min-w-40 items-center gap-2 rounded-lg border border-gray-200 bg-white px-2 py-2 text-left shadow-sm">
    <span className="h-8 w-8 shrink-0 rounded-full border border-gray-300 shadow-inner" style={{ backgroundColor: info.hex || '#e5e7eb' }} aria-hidden="true" />
    <div className="min-w-0"><div className="text-sm font-semibold text-gray-900">{info.description}</div>
      <div className="text-xs font-normal text-gray-500">{[info.code && info.code !== info.description ? info.code : '', variantLabel].filter(Boolean).join(' · ') || 'Color de prenda'}</div>
    </div>
  </div>;
}
